// Default logical stage dimensions; UI can override these at runtime.
export const DEFAULT_STAGE_GRID_WIDTH = 38;
export const DEFAULT_STAGE_GRID_HEIGHT = 23;
export const STAGE_CELL_SIZE = 14;
export const STAGE_PIXEL_WIDTH = DEFAULT_STAGE_GRID_WIDTH * STAGE_CELL_SIZE;
export const STAGE_PIXEL_HEIGHT = DEFAULT_STAGE_GRID_HEIGHT * STAGE_CELL_SIZE;
